/**
 * Credential-bearing JSON fields that must never reach session recordings.
 * `secret` covers the API key provisioning response, which returns the
 * plaintext secret exactly once.
 */
const CREDENTIAL_FIELDS = ["password", "secret", "token", "accessToken", "access_token"];

export function redactCredentials(body) {
  if (typeof body !== "string" || !body) return body;
  return CREDENTIAL_FIELDS.reduce(
    (text, field) =>
      text.replace(
        new RegExp(`"${field}":\\s*"[^"]*"`, "gi"),
        `"${field}": "redacted"`
      ),
    body
  );
}
